import React from "react";
import PropTypes from "prop-types";
import { OMSDropdown } from "../../../app/common/common-components/OMSDropdown";
import { toast } from "react-toastify";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import apiAgent from "../../../app/api/apiAgent";
import DatePicker from "react-datepicker";
import { withRouter } from "react-router-dom";
import { Link } from 'react-router-dom';

const moment = require("moment");

class ReportStepView extends React.Component {
  static propTypes = {
    PropertyID: PropTypes.string,
    UserID: PropTypes.string,
  };

  state = {
    processing: false,
    mPropertyType: true,
    mSaleType: true,
    mPriceRange: true,
    mAreas: true,
    mBuildsize: true,
    mLandsize: true,
    mBeds: true,
    mBaths: true,
    mGarages: true,
    mParkingBays: true,
    mMatchingClients: [],
    mProcessing: false,
    SelectedAgentID: this.props.SelectedAgentID,
    mViewReportFrom: null,
    mViewReportTo: null,
  };

  formatDate = (fullDateString) => {
    const date = new Date(fullDateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());

    return `${day}-${month}-${year}`;
  };

  componentDidMount() {
    //console.log("inside componentDidMount,mViewReportFrom= ",this.getFormattedDate(this.state.mViewReportFrom));
    //console.log('ReportStepView', this.props);
    // window.$('.MandateDatePicker3').datetimepicker({
    //     format: 'DD-MM-YYYY',
    //     useCurrent: false,
    //     maxDate: moment(),
    //     icons: {
    //         time: "fa fa-clock-o",
    //         date: "fa fa-calendar",
    //         up: "fa fa-arrow-up",
    //         down: "fa fa-arrow-down",
    //         previous: "fa fa-arrow-left",
    //         next: "fa fa-arrow-right",
    //         today: 'fa fa-screenshot',
    //         clear: 'fa fa-trash',
    //         close: 'fa fa-remove'
    //     },
    //     widgetPositioning: {
    //         horizontal: 'left',
    //         vertical: 'bottom'
    //     },
    //     widgetParent: '#mainDivForMandateDatePicker3'
    // });
  }

  handleFilterOptionClick = (name) => {
    var value = true;
    if (this.state[name]) value = false;
    this.setState({ [name]: value });
  };

  handleDropdownFieldChange = (e) => {
    this.setState({ SelectedAgentID: e.newValue });
  };

  doSetState = (data) => {};

  doGetState = () => {
    return {};
  };

  handleGenerateBrochureDynamicClick = (BrochureID, IsCrystalReport, exportType) => {
    var mPropertyID = this.props.PropertyID;
    var mShowAddress = window.$("#ShowAddress").is(":checked");
    var mSelectedAgentID = this.state.SelectedAgentID;

    if (IsCrystalReport) {
      this.setState({ processing: true });
      apiAgent.Property.generateBrochureCRAjax(mPropertyID, BrochureID, mSelectedAgentID, mShowAddress)
        .then((response) => {
          var binaryData = [];
          //console.log("inside generateBrochureCRAjax", response);
          binaryData.push(response.data);
          //const uint8Array = new Uint8Array(binaryData);
          // window.URL.createObjectURL(new Blob(binaryData, { type:exportType == "PDF" ?  "application/pdf" : "image/png" }));
          // Create blob link to download
          const url = window.URL.createObjectURL(new Blob(binaryData, { type: exportType == "PDF" ? "application/pdf" : "image/png" }));

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", exportType == "PDF" ? "Brochure.pdf" : "Brochure.png");

          // Append to html link element page
          document.body.appendChild(link);
          //console.log("link inside generateBrochureCRAjax", link);
          // Start download
          link.click();

          // Clean up and remove the link
          link.parentNode.removeChild(link);
        })
        .catch((error) => {
          console.log("error inside listing Report", error);
          toast.error(error.message, "Error", "error");
        })
        .finally(() => {
          this.setState({ processing: false });

        });
    } else {
      this.setState({ processing: true });

      apiAgent.Property.generateBrochureDynamicAjax(mPropertyID, BrochureID, mSelectedAgentID, mShowAddress)
        .then((response) => {
          if (response.status == "success") {
            const a = document.createElement("a");
            a.href = response.message;
            a.setAttribute("download", exportType == "PDF" ? "Brochure.pdf" : "Brochure.png");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }
        })
        .catch((error) => {
          toast.error(error.message, "Error", "error");
          console.log("error inside listing Report", error);
        })
        .finally(() => {
          this.setState({ processing: false });
        });
    }
  };

  handleMatchingClientsClick = (e) => {
    this.setState({
      mPropertyType: true,
      mSaleType: true,
      mPriceRange: true,
      mAreas: true,
      mBuildsize: true,
      mLandsize: true,
      mBeds: true,
      mBaths: true,
      mGarages: true,
      mParkingBays: true,
      mMatchingClients: [],
      mProcessing: false,
    });
    window.$("#matchingReportModel").modal("show");
  };

  handleMatchingClientsRunClick = (e) => {
    // var endUrl = '?PropertyID=' + this.props.PropertyID + '&PriceRange=' + this.state.mPriceRange + '&Areas=' + this.state.mAreas + '&Buildsize=' + this.state.mBuildsize + '&Landsize=' + this.state.mLandsize + '&Beds=' + this.state.mBeds + '&Baths=' + this.state.mBaths + '&Garages=' + this.state.mGarages + '&ParkingBays=' + this.state.mParkingBays;
    // this.setState({ mProcessing: true, mMatchingClients: [] });
    // var xhr = new XMLHttpRequest();
    // xhr.open('get', '/Contacts/RequirementsClientMatchAjax' + endUrl, true);
    // xhr.onload = function () {
    //     var data = JSON.parse(xhr.responseText);
    //     this.setState({ mMatchingClients: data, mProcessing: false });
    //     if (data.length == 0) {
    //         toast.info('No match found');
    //     }
    // }.bind(this);
    // xhr.send();
    this.setState({ mProcessing: true, mMatchingClients: [] });
    //console.log("before api call for matching clients, this.props.PropertyID", this.props.PropertyID);
    apiAgent.Contact.requirementsClientMatchAjax(
      this.props.PropertyID,
      this.state.mPriceRange,
      this.state.mAreas,
      this.state.mBuildsize,
      this.state.mLandsize,
      this.state.mBeds,
      this.state.mBaths,
      this.state.mGarages,
      this.state.mParkingBays
    )
      .then((response) => {
        //console.log("inside matching clients", response);
        this.setState({ mMatchingClients: response, mProcessing: false });
        if (response.length == 0) {
          toast.info("No match found");
        }
      })
      .catch((error) => {
        toast.info("Fail");
      });
  };

  handleListingViewsRunClick = (e) => {
    var mViewReportFrom = document.getElementById("mViewReportFrom").value;
    var mViewReportTo = document.getElementById("mViewReportTo").value;
    this.executeListingViewRun(mViewReportFrom, mViewReportTo);
  };

  executeListingViewRun = (from, to) => {
    // var endUrl = '?ID=' + this.props.PropertyID + '&From=' + from + '&To=' + to;
    // this.setState({ mProcessing: true });
    // var xhr = new XMLHttpRequest();
    // xhr.open('get', '/Property/ListingViewReportAjax' + endUrl, true);
    // xhr.onload = function () {
    //     this.setState({ mProcessing: false });
    //     var data = JSON.parse(xhr.responseText);
    //     if (data.status == "success") {
    //         if (data.result == null || data.result.length == 0)
    //             toast.info("No results found.");
    //         else {
    //             this.setState({ ChartData: data.result, ChartData2: data.result2 }, function () {
    //                 this.setGoogleChartData();
    //             }.bind(this));
    //         }
    //     }
    //     else {
    //         toast.info(data.message);
    //     }
    // }.bind(this);
    // xhr.send();
    this.setState({ mProcessing: true });
    apiAgent.Property.listingViewReportAjax(this.props.PropertyID, from, to)
      .then((response) => {
        if (response.result == null || response.result.length == 0) toast.info("No results found.");
        else {
          //console.log("ChartData", response.result);
          //console.log("ChartData2", response.result2);
          this.setState({ ChartData: response.result, ChartData2: response.result2 }, function () {
            this.setGoogleChartData();
          });
        }
      })
      .catch((error) => {
        toast.info("Fail");
      })
      .finally(() => {
        this.setState({ mProcessing: false });
      });
  };

  setGoogleChartData = () => {
    var isPerPortal = document.getElementById("ViewsPerPortals").checked;
    var dataItem = null;
    if (!isPerPortal) dataItem = this.state.ChartData2;
    else dataItem = this.state.ChartData;

    if (dataItem === undefined || dataItem == null) return;

    var arrTotal = [];
    if (dataItem.length > 1) {
      for (var i = 1; i < dataItem[0].length; i++) {
        var total = 0;
        for (var j = 1; j < dataItem.length; j++) {
          //console.log(dataItem[j][i]);
          total += parseInt(dataItem[j][i]);
        }
        arrTotal.push(total);
      }
    }

    var WebRef = this.props.WebRef;
    var arrData = [];
    for (var i = 0; i < dataItem.length; i++) {
      arrData.push(dataItem[i]);
    }
    const google = window.google;

    google.charts.load("current", { packages: ["corechart", "bar"] }).then(function () {
      var data = new google.visualization.arrayToDataTable(arrData);
      var view = new google.visualization.DataView(data);
      var options = {
        title: "Property view statistics #" + WebRef,
        width: "100%",
        height: 400,
        legend: { position: "top", alignment: "start", maxLines: 3 },
        bar: { groupWidth: "75%" },
        isStacked: true,
      };
      var chart = new google.visualization.ColumnChart(document.getElementById("PageViewChart"));
      google.visualization.events.addListener(chart, "ready", function () {
        if (arrTotal.length != 0) {
          var selected = window.$("#PageViewChart svg text[text-anchor='start']");
          if (selected.length == arrTotal.length + 1) {
            for (var i = 0; i < arrTotal.length; i++) {
              var mText = dataItem[0][i + 1].trim().replaceAll("-", "") + "<tspan font-weight='bold'>(" + arrTotal[i] + ")</tspan>";
              window.$("#PageViewChart svg text[text-anchor='start']")[i + 1].innerHTML = mText;
            }
          }
        }
      });
      chart.draw(data, options);
    });
  };

  handleListingViewsClick = (e) => {
    //console.log("handleListingViewsClick", this.props.Mandate_ExpiryDate);
    var m = moment(this.props.Mandate_ExpiryDate, "DD-MM-YYYY");
    var s = moment();
    if (s.diff(m, "days") >= 0) document.getElementById("mViewReportTo").value = m.format("DD-MM-YYYY");
    else document.getElementById("mViewReportTo").value = s.format("DD-MM-YYYY");

    document.getElementById("mViewReportFrom").value = this.props.Mandate_StartDate;
    document.getElementById("PageViewChart").innerHTML = "";
    document.getElementById("ViewsPerPortals").checked = true;
    document.getElementById("spanReportViewText").innerHTML = "Views per portal";

    const formattedmViewReportFrom = this.props.Mandate_StartDate ? this.getFormattedDate(this.props.Mandate_StartDate) : "";
    const formattedmViewReportTo = document.getElementById("mViewReportTo").value ? this.getFormattedDate(document.getElementById("mViewReportTo").value) : "";

    this.setState({
      mViewReportFrom: formattedmViewReportFrom,
      mViewReportTo: formattedmViewReportTo,
    });
    //console.log("handleListingViewsClick, set state: ", this.state.mViewReportTo);
    window.$("#listingViewReportModel").modal("show");
    this.executeListingViewRun("", "");
  };

  handleViewsPerPortalsChanged = (e) => {
    var text = "Views per portal";
    if (!document.getElementById("ViewsPerPortals").checked) text = "Summary view";
    document.getElementById("spanReportViewText").innerHTML = text;
    this.setGoogleChartData();
  };

  getReportIcon = (value, tooltip) => {
    if (value == "True") {
      return (
        <span>
          <i className="fa fa-check-circle" title="requirements matched" style={{ color: "green" }}></i>
        </span>
      );
    } else if (value == "False") {
      return (
        <span>
          <i className="fa fa-times-circle" title={"requirements not matched: " + tooltip} style={{ color: "red" }}></i>
        </span>
      );
    } else {
      return (
        <span>
          <i className="fa fa-minus-circle" title="requirement not specified" style={{ color: "grey" }}></i>
        </span>
      );
    }
  };

  getFormattedDate = (date) => {
    //console.log("getFormattedDate", date);
    let format = "DD-MM-yyyy";
    if (date) {
      let isoDateString = moment(date, format).toISOString();
      return new Date(isoDateString);
    } else return null;
  };

  render() {
    var self = this;
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">Brochures</div>
              <div className="panel-body">
                <div className="form-group">
                  <span style={{ marginLeft: 12 }}>
                    Show address on brochure&nbsp;
                    <input type="checkbox" id="ShowAddress" style={{ position: "absolute", marginLeft: 8 }} name="ShowAddress" defaultChecked={false} />
                  </span>
                </div>
                <div className="form-group form-inline">
                  <span style={{ marginLeft: 12, marginRight: 8 }}>Agent name on brochure&nbsp;</span>
                  <OMSDropdown
                    id="AgentNameOnBrochure"
                    name="AgentNameOnBrochure"
                    options={this.props.AgentDD}
                    valueField="value"
                    labelField="text"
                    value={this.state.SelectedAgentID}
                    onChange={this.handleDropdownFieldChange}
                  />
                </div>
                <div className="brochure-list">
                  {this.props.Brochures.map((data, index) => (
                    <div key={data.brochureID + "-" + index} className={`brochure-item ${!data.isGeneric ? "custom-brochure" : ""}`}>
                      <div
                        className="brochure-preview"
                        style={{
                          backgroundImage: data.brochurePreviewUrl
                            ? "url(" + data.brochurePreviewUrl + ")"
                            : "url(https://etbrochure.s3.eu-west-1.amazonaws.com/preview/default.jpg)",
                        }}
                      ></div>
                      <div className="brochure-title">
                        {data.fileType == 1 ? (
                          <OMSButtonStyleL
                            type="button"
                            ui_icon={data.exportType == "PNG" ? "fa-file-image-o" : "fa-file-pdf-o"}
                            ui_type="cancel"
                            ui_text={data.brochureName}
                            ui_processing_text="Generating.."
                            processing={self.state.processing}
                            disabled={self.state.processing}
                            onClick={() => self.handleGenerateBrochureDynamicClick(data.brochureID, true, data.exportType)}
                          />
                        ) : (
                          <OMSButtonStyleL
                            type="button"
                            ui_icon={data.exportType == "PNG" ? "fa-file-image-o" : "fa-file-pdf-o"}
                            ui_type="cancel"
                            ui_text={data.brochureName}
                            ui_processing_text="Generating.."
                            processing={self.state.processing}
                            disabled={self.state.processing}
                            onClick={() => self.handleGenerateBrochureDynamicClick(data.brochureID, false, data.exportType)}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">Reports</div>
              <div className="panel-body">
                {this.props.ShowChart ? (
                  <div className="form-group">
                    <OMSButtonStyleL
                      type="button"
                      ui_icon="fa-bar-chart"
                      ui_type="cancel"
                      ui_text=" Listing views"
                      ui_processing_text="Processing.."
                      processing={this.state.processing}
                      disabled={this.state.processing}
                      onClick={this.handleListingViewsClick}
                    />
                  </div>
                ) : (
                  <div className="form-group">
                    <a href="javascript:void(0)" style={{ cursor: "not-allowed", color: "#333" }} title="Not enabled for office" className="btn">
                      <span className="fa fa-bar-chart"></span> Listing views
                    </a>
                  </div>
                )}
                <div className="form-group">
                  <OMSButtonStyleL
                    type="button"
                    ui_icon="fa-file-text-o"
                    ui_type="cancel"
                    ui_text=" Matching clients"
                    ui_processing_text="Generating.."
                    processing={this.state.processing}
                    disabled={this.state.processing}
                    onClick={this.handleMatchingClientsClick}
                  />
                </div>
              </div>
            </div>
            <div className="modal fade" id="matchingReportModel" tabIndex={-1} aria-labelledby="matchingReportModelLabel" aria-hidden="true">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                      ×
                    </button>
                    <h4 className="modal-title" id="matchingReportModelLabel">
                      Matching clients report
                    </h4>
                  </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-md-12">
                        <label>Select criteria to filter on</label>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 10 }}>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mPriceRange")}>
                          <span className="color-preview">
                            {this.state.mPriceRange ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Price range</span>
                        </span>
                      </div>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mAreas")}>
                          <span className="color-preview">
                            {this.state.mAreas ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Areas</span>
                        </span>
                      </div>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mBuildsize")}>
                          <span className="color-preview">
                            {this.state.mBuildsize ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Floor size</span>
                        </span>
                      </div>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mLandsize")}>
                          <span className="color-preview">
                            {this.state.mLandsize ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Land size</span>
                        </span>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 10 }}>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mBeds")}>
                          <span className="color-preview">
                            {this.state.mBeds ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Beds</span>
                        </span>
                      </div>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mBaths")}>
                          <span className="color-preview">
                            {this.state.mBaths ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Baths</span>
                        </span>
                      </div>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mGarages")}>
                          <span className="color-preview">
                            {this.state.mGarages ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Garages</span>
                        </span>
                      </div>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color" onClick={() => this.handleFilterOptionClick("mParkingBays")}>
                          <span className="color-preview" style={{ cursor: "pointer" }}>
                            {this.state.mParkingBays ? <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i> : null}
                          </span>
                          <span className="color-label">Parking bays</span>
                        </span>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 10 }}>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color">
                          <span className="color-preview" style={{ backgroundColor: "#ccc" }}>
                            <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i>
                          </span>
                          <span className="color-label">Sale type</span>
                        </span>
                      </div>
                      <div className="col-md-3 col-sm-6 col-xs-6">
                        <span className="multiselect-color">
                          <span className="color-preview" style={{ backgroundColor: "#ccc" }}>
                            <i className="fa fa-check" aria-hidden="true" style={{ color: "black" }}></i>
                          </span>
                          <span className="color-label">Property type</span>
                        </span>
                      </div>
                      <div className="col-md-6 col-sm-12 col-xs-12"></div>
                    </div>
                    {this.state.mMatchingClients.length == 0 ? null : (
                      <div>
                        <div className="row" style={{ marginTop: 20 }}>
                          <div className="col-md-12">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Sale type</th>
                                  <th>Property type</th>
                                  <th>Price range</th>
                                  <th>Area</th>
                                  <th>Floor size</th>
                                  <th>Land size</th>
                                  <th>Beds</th>
                                  <th>Baths</th>
                                  <th>Garages</th>
                                  <th>Parking bays</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.mMatchingClients.map(function (data, index) {
                                  return (
                                    <tr key={data.contactID}>
                                      <td>
                                        {/* <a href={"/Contacts/SaveContact?ID=" + data.ContactID} target="_blank">
                                          {data.name}
                                  </a> */}
                                        <Link to={`/Contacts/SaveContact?ID=${data.contactID}`} target="_blank">
                                          {data.name}
                                        </Link>
                                      </td>
                                      <td>{self.getReportIcon(data.saleType, "")}</td>
                                      <td>{self.getReportIcon(data.propertyType, "")}</td>
                                      <td>{self.getReportIcon(data.price, data.tPrice)}</td>
                                      <td>{self.getReportIcon(data.areas, data.tAreas)}</td>
                                      <td>{self.getReportIcon(data.floorsize, data.tFloorsize)}</td>
                                      <td>{self.getReportIcon(data.landsize, data.tLandsize)}</td>
                                      <td>{self.getReportIcon(data.beds, data.tBeds)}</td>
                                      <td>{self.getReportIcon(data.baths, data.tBaths)}</td>
                                      <td>{self.getReportIcon(data.garages, data.tGarages)}</td>
                                      <td>{self.getReportIcon(data.parkingBays, data.tParkingBays)}</td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <a style={{ marginRight: 20, cursor: "pointer" }} data-dismiss="modal">
                      Close
                    </a>
                    <OMSButtonStyleL
                      type="button"
                      ui_icon="fa-check"
                      ui_type="save"
                      ui_text="Run"
                      ui_processing_text="Running.."
                      processing={this.state.mProcessing}
                      disabled={this.state.mProcessing}
                      onClick={this.handleMatchingClientsRunClick}
                    />

                    {/*<button type="button" className="btn btn-default" data-dismiss="modal">Close</button>*/}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal fade" id="listingViewReportModel" tabIndex={-1} aria-labelledby="listingViewReportModelLabel" aria-hidden="true">
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                      ×
                    </button>
                    <h4 className="modal-title" id="listingViewReportModelLabel">
                      listing views report
                    </h4>
                  </div>
                  <div className="modal-body">
                    <div className="row" style={{ marginTop: 10 }}>
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <label>Date range</label>
                      </div>
                      <div id="mainDivForMandateDatePicker3" className="col-md-12 col-sm-12 col-xs-12 marginBottom10">
                        {/* <input type="text" placeholder="From date" style={{ width: 150, display: 'inline-block', marginRight: 5 }} className="form-control MandateDatePicker3" id="mViewReportFrom" name="mViewReportFrom" /> */}
                        <DatePicker
                          selected={this.getFormattedDate(this.state.mViewReportFrom)}
                          //onChange={(date) => this.setState({ mViewReportFrom: (date == null ? "" : moment(date).format("DD-MM-YYYY")) })}
                          onChange={(date) => this.setState({ mViewReportFrom: date })}
                          dateFormat="dd-MM-yyyy"
                          value={this.state.mViewReportFrom}
                          placeholderText="From date"
                          name="mViewReportFrom"
                          id="mViewReportFrom"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          //style={{ width: 150, display: 'inline-block', marginRight: 5 }}
                          className="form-control MandateDatePicker3"
                          isClearable={true}
                        />
                        {/* <input
                          type="text"
                          placeholder="To date"
                          style={{ width: 150, display: "inline-block", marginRight: 10, marginTop: 5 }}
                          className="form-control MandateDatePicker3"
                          id="mViewReportTo"
                          name="mViewReportTo"
                            /> */}
                        <DatePicker
                          selected={this.getFormattedDate(this.state.mViewReportTo)}
                          onChange={(date) => this.setState({ mViewReportTo: date })}
                          dateFormat="dd-MM-yyyy"
                          value={this.state.mViewReportTo}
                          placeholderText="To date"
                          id="mViewReportTo"
                          name="mViewReportTo"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          //style={{ width: 150, display: "inline-block", marginRight: 10, marginTop: 5 }}
                          className="form-control MandateDatePicker3"
                          isClearable={true}
                        />
                        <label className="switch" style={{ marginTop: 10 }}>
                          <input
                            type="checkbox"
                            id="ViewsPerPortals"
                            name="ViewsPerPortals"
                            defaultChecked={true}
                            onChange={this.handleViewsPerPortalsChanged}
                          />
                          <div className="slider round" />
                          <span id="spanReportViewText" style={{ marginLeft: 70, display: "block", width: 120, marginTop: 7 }}>
                            Views per portal
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="row" style={{ marginTop: 25, marginBottom: 15 }}>
                      <div className="col-md-12">
                        <div id="PageViewChart"></div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <div className="pull-left">
                      <a href="https://help.entegral.net/en/articles/5631079-listing-view-reports" target="_blank">
                        Help with listing views
                      </a>
                    </div>
                    <a style={{ marginRight: 20, cursor: "pointer" }} data-dismiss="modal">
                      Close
                    </a>
                    <OMSButtonStyleL
                      type="button"
                      ui_icon="fa-check"
                      ui_type="save"
                      ui_text="View"
                      ui_processing_text="Viewing.."
                      processing={this.state.mProcessing}
                      disabled={this.state.mProcessing}
                      onClick={this.handleListingViewsRunClick}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ReportStepView);
